<template>
	<v-col class="ma-0 pa-5" cols="12">
		<!-- 상단: 우측 cctv_plus 아이콘만 (카메라 선택/리스트 작성 없음) -->
		<v-row class="ma-0 pa-0 mb-3" justify="end">
			<v-btn id="transparent_btn" elevation="0" @click="openCameraSearch">
				<v-img id="cctv_icon" src="@/assets/images/cctv_plus.png"></v-img>
			</v-btn>
		</v-row>
		<!-- 카메라 목록: 반드시 4열 종대. 썸네일별 v-menu 없음. -->
		<template v-if="streamingUrlLoading == false">
			<v-row class="ma-0 pa-0" v-if="cameraList.length > 0">
				<v-col class="ma-0 pa-2" cols="3" v-for="(item, index) in cameraList" :key="index">
					<div class="cg_thumb" style="cursor:pointer;" @click="goVideoPlayer(item)">
						<template v-if="item.offline">
							<div class="cg_offline">{{ t('offline') }}</div>
						</template>
						<template v-else>
							<img v-if="item.thumbnailSrc && imageError[index] === false" :src="item.thumbnailSrc" class="cg_img" @error="thumbnailError(index, $event)"/>
							<v-col v-else-if="imageError[index]" class="ma-0 pa-0" style="background-color: rgb(69, 69, 69); height: 100%; align-content: center;">
								<div>サムネイル・エラー</div>
							</v-col>
							<v-skeleton-loader v-else type="image" dark class="cg_img_skeleton" :boilerplate="false"
								elevation="0"></v-skeleton-loader>
						</template>
						<div class="cg_name ellipsis">{{ item.cameraName }}</div>
					</div>
				</v-col>
			</v-row>
			<v-col class="ma-0 pa-10" cols="12" align="center" id="cg_nodata" v-else>
				{{ t('noData') }}
			</v-col>
		</template>
		<template v-else>
			<v-col class="ma-0 pa-10" cols="12" align="center">
				<v-progress-circular indeterminate color="white" :width="4" :size="30"></v-progress-circular>
			</v-col>
		</template>

		<!-- 카메라 추가 (cctv_plus): 카메라그룹 생성과 동일한 카메라 선택 UI (그룹명 없음) -->
		<CameraGroupAddDialog :dialogVisible="cameraSearchDialogVisible" @visible="cameraSearchDialogVisibleFunc"
			@add="addSelectedCamerasFunc" />
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import CameraGroupAddDialog from '@/components/dialogs/CameraGroupAddDialog.vue';
export default {
	components: {
		CameraGroupAddDialog
	},
	mixins: [mixin.common],
	data: () => ({
		currentGroupId: '',   // = 카메라그룹 id (route query)
		groupName: '',
		cameraList: [],
		streamingUrlLoading: false,
		cameraSearchDialogVisible: false,
		imageError: [],
	}),
	watch: {
		'$route.query.groupId': function (val) {
			this.currentGroupId = val;
			this.getCheckListCameras();
		}
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
	},
	mounted() {
		this.getCheckListCameras();
	},
	methods: {
		// 카메라그룹의 카메라 목록 조회 후 각 카메라 썸네일 로드
		getCheckListCameras() {
			if (!this.currentGroupId) return;
			this.streamingUrlLoading = true;
			this.networkController.getCameraCheckListGroup({}, this.currentGroupId)
				.then((res) => {
					this.groupName = res.data.groupName;
					this.cameraList = (res.data.cameras || []).map((c) => ({
						...c, thumbnailSrc: null, offline: false
					}));
					this.streamingUrlLoading = false;
					this.cameraList.forEach((item, index) => this.loadThumbnail(item, index));
					this.imageError = new Array(this.cameraList.length).fill(false);
				}).catch(() => {
					this.streamingUrlLoading = false;
				});
		},
		// 카메라 썸네일 로드 (webrtc 준비 시 S3 썸네일, 아니면 KVS 이미지. 실패 시 오프라인)
		async loadThumbnail(item, index) {
			if (item.webrtc && item.webrtc.playback && item.webrtc.playback.ready) {
				this.$set(this.cameraList[index], 'thumbnailSrc', item.thumbnail);
				return;
			}
			try {
				await this.networkController.getDashStreamingUrl({}, item.streamName, '', '');
				try {
					const imgList = await this.networkController.awsGetThumbnail(item.streamName);
					this.$set(this.cameraList[index], 'thumbnailSrc', 'data:image/png;base64,' + imgList.ImageContent);
				} catch (e) {
					this.$set(this.cameraList[index], 'offline', true);
				}
			} catch (e) {
				this.$set(this.cameraList[index], 'offline', true);
			}
		},
		thumbnailError(index) {
			this.$set(this.imageError, index, true);
			// this.imageError[index] = true;
		},
		// 썸네일 클릭 → /video-player 로 이동하여 해당 카메라 영상 재생
		async goVideoPlayer(item) {
			this.$vloading.show();
			this.$store.commit('setPlayerFromWhere', { from: 'cameraList', name: this.groupName });
			await this.$store.commit('setStreamInfo', item);
			this.$vloading.hide();
			this.pushRoute('/video-player', {
				unisCustomerCd: item.unisCustomerCd,
				customerName: item.cameraName,
				groupId: this.currentGroupId,
			});
		},
		openCameraSearch() {
			this.cameraSearchDialogVisible = true;
		},
		cameraSearchDialogVisibleFunc(visible) {
			this.cameraSearchDialogVisible = visible;
		},
		// 카메라 추가 (다중 선택) → addCameraToCameraList → 목록 재조회
		async addSelectedCamerasFunc(selectedCameras) {
			if (!selectedCameras || selectedCameras.length === 0) return;
			const payload = [];
			selectedCameras.forEach((cam) => {
				const exists = this.cameraList.findIndex(r => r.contractCd === cam.contractCd && r.portNo === cam.portNo);
				if (exists === -1) {
					payload.push({
						cameraName: cam.cameraName,
						contractCd: cam.contractCd,
						portNo: cam.portNo,
						unisCustomerCd: cam.unisCustomerCd,
						thingType: cam.thingType,
						size: 1,
					});
				}
			});
			if (payload.length === 0) return;
			this.$vloading.show();
			await this.networkController.addCameraToCameraList(payload, this.currentGroupId)
				.then(() => {
					this.showToastMessage(this.tmb('requestSuccess'));
					this.$vloading.hide();
					this.getCheckListCameras();
				}).catch(() => {
					this.showToastMessage(this.tmb('requestFail'));
					this.$vloading.hide();
				});
		},
	}
}
</script>

<style lang="scss" scoped>
#transparent_btn {
	background-color: transparent;
	max-width: 3em;
	min-width: 3em;
}

#cctv_icon {
	width: 2rem;
	height: 2rem;
}

.cg_thumb {
	position: relative;
	width: 100%;
	height: 11rem;
	background-color: #222222;
}

.cg_img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.cg_img_skeleton {
	width: 100%;
	height: 100%;
}

.cg_offline {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	background-color: #3A3A3A;
}

.cg_name {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 2px 8px;
	background-color: rgba(0, 0, 0, 0.75);
	color: #BEBEBE;
	font-size: 0.8rem;
	text-align: left;
}

.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

::v-deep .cg_img_skeleton .v-skeleton-loader__image {
	height: 11rem;
}
</style>
